import React, { useEffect, useRef, useState } from "react";
import * as styles from "./SideBar.module.css";
import { NavLink, useLocation } from "react-router-dom";
import { sideBarNavLinks as navTree } from "../../utils/constants";

const SideBar = () => {
  const [sideBarVisible, setSideBarVisible] = useState();
  const sidebarRef = useRef();
  const [expandedItems, setExpandedItems] = useState({});
  const hamburgerRef = useRef();
  const location = useLocation();

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setSideBarVisible(true);
    } else {
      setSideBarVisible(false);
    }
  };

  useEffect(() => {
    const path = location.pathname;

    const expandedItem = {};

    const traverseTree = (items) => {
      let shouldExpandParent = false;
      items.map((item) => {
        let shouldExpandThis = false;
        if (path.startsWith(item.path)) {
          expandedItem[item.path] = true;
          shouldExpandThis = true;
        }

        if (Array.isArray(item.child)) {
          const childExpanded = traverseTree(item.child);

          if (childExpanded) {
            expandedItem[item.path] = true;
            shouldExpandThis = true;
          }
        }
        if (shouldExpandThis) {
          shouldExpandParent = true;
        }
      });

      return shouldExpandParent;
    };

    traverseTree(navTree);
    setExpandedItems(expandedItem);

    setSideBarVisible(window.innerWidth > 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!sideBarVisible) return;

    const handleClickOutside = (event) => {
      const clickTarget = event.target;
      const isMobileView = window.innerWidth < 992;

      const sidebarEl = sidebarRef.current;
      const hamburgerEl = hamburgerRef.current;

      const clickedOutsideSidebar =
        sidebarEl && !sidebarEl.contains(clickTarget);
      const clickedOutsideHamburger =
        hamburgerEl && !hamburgerEl.contains(clickTarget);

      if (isMobileView && clickedOutsideSidebar && clickedOutsideHamburger) {
        setSideBarVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [sideBarVisible]);

  const toggleSideBarFunction = () => {
    setSideBarVisible((prev) => !prev);
  };

  const toggleAdminSubMenu = (identifier) => {
    setExpandedItems((prev) => ({
      ...prev,
      [identifier]: !prev[identifier],
    }));
  };

  const renderNavItems = (items, depth = 0) => {
    return (
      <ul className={depth === 0 ? styles.navList : styles.subMenu}>
        {items.map(
          ({
            path,
            child = [],
            name,
            Wrapper = React.Fragment,
            wrapperProps = {},
          }) => {
            const haschild = child && child.length > 0;
            const isExpanded = expandedItems[path];
            return (
              <Wrapper {...(wrapperProps ?? {})} key={name}>
                <li>
                  {haschild ? (
                    <>
                      <button
                        className={styles.navToggle}
                        onClick={() => toggleAdminSubMenu(path)}
                      >
                        {name}
                        <svg
                          className={`${styles.arrowIcon} ${
                            isExpanded ? styles.rotate : ""
                          }`}
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            d="M6 9l6 6 6-6"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      <div
                        className={`${styles.subNavWrapper} ${
                          isExpanded ? styles.expanded : styles.collapsed
                        }`}
                      >
                        {renderNavItems(child, depth + 1)}
                      </div>
                    </>
                  ) : (
                    <>
                      <NavLink
                        to={path}
                        className={({ isActive }) => {
                          const baseClass = styles.navLink;
                          const activeClass = isActive ? styles.active : "";
                          const depthClass = styles[`depth${depth}`] || "";
                          return `${baseClass} ${activeClass} ${depthClass}`;
                        }}
                        onClick={() => {
                          if (window.innerWidth < 968) setSideBarVisible(false);
                        }}
                      >
                        {name}
                      </NavLink>
                    </>
                  )}
                </li>
              </Wrapper>
            );
          }
        )}
      </ul>
    );
  };

  return (
    <div>
      {sideBarVisible && (
        <aside className={`${styles.sidebar} blur_card`} ref={sidebarRef}>
          <h2 className={styles.title}>IQ HUB</h2>
          {renderNavItems(navTree)}
        </aside>
      )}
      <div
        onClick={toggleSideBarFunction}
        className={`${styles.hamBurgerIcon} ${
          sideBarVisible ? styles.open : ""
        }`}
        ref={hamburgerRef}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default SideBar;
